export const capitalize = (str: string) =>
  `${str?.charAt(0).toUpperCase()}${str?.slice(1)}` || ''

export const deleteSpaces = (str: string) =>
  str.replace(/\s/g, '')

export const replaceUnderscore = (str: string, replacement: string = ' ') =>
  str.replace(/_/g, replacement)

export const maskValue = (value: string, mask: string) => {
  if (!value) {
    return value
  }

  let maskedValue = ''

  for (let i = 0, j = 0; i < mask.length; i++) {
    if (!value[j]) {
      break
    }

    if (mask[i] !== '#') {
      maskedValue += mask[i]
    } else {
      maskedValue += value[j]
      j++
    }
  }

  return maskedValue
}
